module.exports = __webpack_public_path__ + "static/img/XB30.b6466d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XB30.png
// module id = NA4a
// module chunks = 2